import { h, Key } from 'preact'
import { Highlight } from 'react-instantsearch-dom'

import {
  SearchType,
  GetItemPropsFn,
  isCommunityResult,
  SearchResultWithMetadata
} from './'
import Icon from '../../assets'

interface Props {
  key: Key
  hit: SearchResultWithMetadata
  isHighlited: boolean
  getItemProps: GetItemPropsFn
  type: SearchType
  index: number
}

type SearchContentTypeIcon = 'article' | 'conversation' | 'question' | 'ideation' | 'answer' | 'externalLink' | 'calendar' | 'productUpdate'

const SearchResult = (props: Props) => {
  const {
    key,
    hit,
    isHighlited,
    type,
    getItemProps,
    index
  } = props

  let icon: SearchContentTypeIcon = 'externalLink'
  if (isCommunityResult(hit)) {
    if (hit.content_type === 'question' && hit.has_answer) {
      icon = 'answer'
    } else if (hit.content_type === 'event') {
      icon = 'calendar'
    } else {
      icon = hit.content_type
    }
  }

  const target = !isCommunityResult(hit) ? '_blank' : ''
  const rel = !isCommunityResult(hit) ? 'noreferrer' : ''

  return (
    <li
      key={key}
      className={`algolia-search-result algolia-search-result--${type}`}
      style={{ backgroundColor: isHighlited ? '#F2F2F2' : '' }}
    >
      <a
        target={target}
        rel={rel}
        href={hit.topic_url ?? ''}
        className='algolia-hit-item button-click'
        {...getItemProps({ item: hit, index })}
        onMouseUp={(e: Event) => e.stopPropagation()}
      >
        <Icon customClass='algolia-hit-item--icon' width={20} height={20} icon={icon} />
        <span className='algolia-hit-item--name'>
          {hit._highlightResult
            ? <Highlight attribute='title' hit={hit} tagName='strong' />
            : hit.title}
          {' '}
          {isCommunityResult(hit) && hit.content_type === 'article' && hit.article_label
            ? <span className='hit-item--meta'> {hit.article_label}</span>
            : null}
        </span>
      </a>
    </li>
  )
}

export default SearchResult
